import React from 'react'

const Sidead = (props) => {
    return (
        <div>
          
                <div className="element1">
                    <div className="smallimg"><img src={props.imgsrc1} ></img></div>
                    <div className="itsinfo">
                        <div className="headingside">Beauty</div>
                        <div className="paragraph">Lorem, ipsum dolor sit amet consectetur adipisicing elit.</div>
                        <div className="credit">by avanti dalal</div>
                    </div>
                </div>
                </div>
    )
}

export default Sidead
